export const appConstant = {
  TODO_OVERVIEW: "TODO_OVERVIEW",
  GRAPH_OVERVIEW: "GRAPH_OVERVIEW",
  OPERATOR: "OPERATOR",
  NCAA: "NCAA",
};

// localStorageKeys
export const localStorageKeys = {
  CharterUser: "CharterUser",
};

// AppId for makerchecker
export const AppId =
  process.env.NODE_ENV === "development"
    ? 14
    : //@ts-ignore
      window.env.AppId;
      

// APIs url

export const API = {
  base_url: "https://newcharterapitest.azurewebsites.net",
  makerchecker_base_url: "https://makercheckerapi.test.vggdev.com",
  cms_base_url: "https://tranzitechfaqapi.test.vggdev.com",
  login: "/Account/login",
  flight: "/Flight",
  aircraft_category: "/Utilities/AircraftCategory",
  forgotPassword: "/Account/forgot-password",
  resetPassword: "/Account/reset-password",
  accountActivation: "/Account/activate",
  operator: "/Organization",
  fileUpload: "/Utilities/file",
  role: "/Role",
  billing: "/Billing",
  utility: "/Utilities",
  aircraft: "/Aircraft",
  organization: "/Organization",
  flight_tracker: "/DashBoard/Tracker",
  settings: "/Setting",
  manifest_tracker: "/DashBoard/ManifestTracker",
  pncf_tracker: "/DashBoard/PNCF",
  organization_list: "/Utilities/OrganizationType",
  analytics: "/DashBoard/Analytics",
  flight_operations: "Flight/billableFlights",
  download_manifest_report: "/DashBoard/ManifestReport",
  download_pncf_report: "/DashBoard/PNCFReport",
  get_notification: "/Notification",
  notificatification_type: "/Utilities/NotificationType",
  notification_status: "/Notification",
  download_analytics_report: "/DashBoard/AnalyticsReport",
  download_flight_report: "/DashBoard/FlightReport",
  makerchecker: "/MakerChecker",
  makerchecker_entities: "/RoleEntity/Application",
  makerchecker_search: "/SearchMakerChecker",
  makerchecker_by_id: "/GetMakerCheckerById",
  makerchecker_treat: "/ApproveMakerChecker",
  makerchecker_decline: "/RejectMakerChecker",
  audit_action: "/AuditAction",
  audit_log: "/Audit",
  download_audit_log: "/Audit/report",
  operator_list: "/Organization/operators",
  cms_faqs: "/Faq/GetProductFaqs",
  resend_operator_invite: "/User/resend-activation-link",
  download_pncf_flight_report: "/DashBoard/PNCFTrackerReport"
};
